import type { PropsWithChildren, ReactNode } from 'react'

import styles from './AppLayout.module.css'

type TAppLayoutProps = PropsWithChildren<{
    header: ReactNode
    footer: ReactNode
    /** After the footer, outside `main` — regions that are not page content: toaster, modal hosts. */
    overlays?: ReactNode
}>

/**
 * The grid lives on the element the app mounts into, so this component renders no box of its own —
 * the server template puts this class on `.js-page` and the client renders straight into it.
 */
export const APP_LAYOUT_CLASS = styles.appLayout

export const AppLayout = ({ header, footer, overlays, children }: TAppLayoutProps) => (
    <>
        {header}
        <main className={styles.main}>{children}</main>
        {footer}
        {overlays}
    </>
)
